import StatusChip from '../../components/StatusChip';
import { OVERALL_DOCUMENT_STATUS_COLORS, OVERALL_DOCUMENT_STATUS_LABELS } from '../../constants/peppolStatusConstants';

const DocumentTableStatusChip = ({ status, size = 'small', variant = 'filled', className, sx }) => {
  // Get status label and color from constants
  const label = OVERALL_DOCUMENT_STATUS_LABELS[status];
  const color = OVERALL_DOCUMENT_STATUS_COLORS[status];

  if (!label || !color) {
    console.warn(`Unknown status: ${status}`);
    return null;
  }

  return <StatusChip color={color} label={label} size={size} variant={variant} className={className} sx={sx} />;
};

export default DocumentTableStatusChip;
